import { render } from "./WatchlistAdd.vue?vue&type=template&id=38efb6d8&scoped=true"
import script from "./WatchlistAdd.vue?vue&type=script&lang=js"
export * from "./WatchlistAdd.vue?vue&type=script&lang=js"

import "./WatchlistAdd.vue?vue&type=style&index=0&id=38efb6d8&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38efb6d8"]])

export default __exports__